export default "__VITE_ASSET__6aebffa5__"